import { Route } from '@angular/router';

export const organizationRoutes: Route[] = [
  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./list/organization-list.component').then(
            (m) => m.OrganizationListComponent
          ),
      },
      {
        path: 'add',
        loadComponent: () =>
          import('./detail/organization-detail.component').then(
            (m) => m.OrganizationDetailComponent
          ),
      },
      {
        path: 'edit/:organizationId',
        loadComponent: () =>
          import('./detail/organization-detail.component').then(
            (m) => m.OrganizationDetailComponent
          ),
      },
    ],
  },
];
